module.exports = __webpack_public_path__ + "media/images/desktop-timer-f0e0377c.png";